import { useLayoutEffect, useRef } from "react";

export const useScrollIntoViewWithinContainer = <T extends HTMLElement>(
  container: HTMLElement | null,
  shouldScrollIntoView?: boolean,
) => {
  const elementRef = useRef<T | null>(null);

  useLayoutEffect(() => {
    const element = elementRef.current;

    if (!shouldScrollIntoView || !element || !container) return;

    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const targetScrollTop =
      container.scrollTop +
      elementRect.top -
      containerRect.top -
      (container.clientHeight - element.clientHeight) / 2;

    container.scrollTo({
      behavior: "smooth",
      top: Math.max(0, targetScrollTop),
    });
  }, [container, shouldScrollIntoView]);

  return elementRef;
};
